import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';


const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 38,
    height: 22,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: 'var(--color-hp-bg-primary)',
            '& + .MuiSwitch-track': {
                backgroundColor: 'var(--color-hp-primary)',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: 'var(--color-hp-med-blue)',
            border: '6px solid var(--color-hp-bg-primary)',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: 'var(--color-hp-bg-disabled)',
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 17,
        height: 17,
        color: 'var(--color-hp-bg-primary)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: 'var(--color-hp-border-secondary)',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

export default IOSSwitch;
